var exports = {
  "k": "xe7b6e3d6--d0419e--container",
};

module.exports = exports;
